module.exports = __webpack_public_path__ + "img/1-sm.d871915f.jpg";